import { useContext } from "react";
import { ViloyatContext } from "./ViloyatContext";

export default function useViloyat() {
  return useContext(ViloyatContext);
}
